import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatRadioModule } from '@angular/material/radio';
import { HttpClientModule } from '@angular/common/http';
import { HeaderComponent } from './header/header.component';
import { MatSliderModule } from '@angular/material/slider';
import { CtxmenuComponent } from './shared/ctxmenu/ctxmenu.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DistanzaIponimiaComponent } from './distanza_relazioni/distanza-iponimia/distanza-iponimia.component';
import { DistanzaMeronimiaComponent } from './distanza_relazioni/distanza-meronimia/distanza-meronimia.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LayoutMenuComponent } from './layout-menu/layout-menu.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { PannelloFiltroMultiploComponent } from './pannello-filtro-multiplo/pannello-filtro-multiplo.component';
import { HeaderNavigazioneMultiplaComponent } from './header-navigazione-multipla/header-navigazione-multipla.component';
import { NewElementsComponent } from './creaElementi/new-elements/new-elements.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DialogModifyNodeComponent } from './creaElementi/dialog-modify-node/dialog-modify-node.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    CtxmenuComponent,
    DistanzaIponimiaComponent,
    DistanzaMeronimiaComponent,
    LayoutMenuComponent,
    PannelloFiltroMultiploComponent,
    HeaderNavigazioneMultiplaComponent,
    NewElementsComponent,
    DialogModifyNodeComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatCheckboxModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatInputModule,
    FormsModule,
    MatDialogModule,
    ScrollingModule,
    MatRadioModule,
    HttpClientModule,
    MatSliderModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatButtonToggleModule,
    DragDropModule
  ],
  providers: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
